import ELEMENT from 'element-ui/lib/element-ui.common';

import normalizeWheel from 'normalize-wheel';
import lib_directives_mousewheel from 'element-ui/lib/directives/mousewheel';

const on = function (el, event, fn, ...args) {
  el.addEventListener(event, fn, ...args);

  this.$once('hook:beforeDestroy', () => {
    el.removeEventListener(event, fn);
  });
};

// eslint-disable-next-line
{
  ELEMENT.Dropdown.methods.initEvent = function () {
    let { trigger, show, hide, handleClick, splitButton, handleTriggerKeyDown, handleItemKeyDown } = this;
    this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;

    let dropdownElm = this.dropdownElm;

    const _on = on.bind(this);
    _on(this.triggerElm, 'keydown', handleTriggerKeyDown); // triggerElm keydown
    _on(dropdownElm, 'keydown', handleItemKeyDown, true); // item keydown

    // 控制自定义元素的样式
    if (!splitButton) {
      _on(this.triggerElm, 'focus', () => {
        this.focusing = true;
      });
      _on(this.triggerElm, 'blur', () => {
        this.focusing = false;
      });
      _on(this.triggerElm, 'click', () => {
        this.focusing = false;
      });
    }
    if (trigger === 'hover') {
      _on(this.triggerElm, 'mouseenter', show);
      _on(this.triggerElm, 'mouseleave', hide);
      _on(dropdownElm, 'mouseenter', show);
      _on(dropdownElm, 'mouseleave', hide);
    } else if (trigger === 'click') {
      _on(this.triggerElm, 'click', handleClick);
    }
  };
}

// eslint-disable-next-line
{
  ELEMENT.Tree.mounted = function () {
    this.initTabIndex();
    on.bind(this)(this.$el, 'keydown', this.handleKeydown);
  };
}

// eslint-disable-next-line
{
  const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

  const mousewheel = function (element, callback) {
    if (element && element.addEventListener) {
      element.__mouseWheelHandler__ = function (event) {
        const normalized = normalizeWheel(event);
        callback && callback.apply(this, [event, normalized]);
      };
      element.__eventName__ = isFirefox ? 'DOMMouseScroll' : 'mousewheel';
      element.addEventListener(element.__eventName__, element.__mouseWheelHandler__);
    }
  };

  lib_directives_mousewheel.bind = function (el, binding) {
    mousewheel(el, binding.value);
  };

  lib_directives_mousewheel.unbind = function (el) {
    if (el && el.__eventName__ && el.__mouseWheelHandler__) {
      el.removeEventListener(el.__eventName__, el.__mouseWheelHandler__);
    }
  };
}



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-polyfill.js